function androidOrIOS() {
  const userAgent = navigator.userAgent;
  if(/android/i.test(userAgent)){
    return 'android';
  }
  if(/iPad|iPhone|iPod/i.test(userAgent)){
    return 'ios';
  }
  return 'desktop';
}

const os = androidOrIOS();

if (os !== "android") {
  window.addEventListener("resize", () => {
    setAATop();
  });
}
